import { useEffect, useRef, useState } from 'react';
import { bulkImportApi } from '../services/adminApi';

const TERMINAL_STATUSES = new Set(['completed', 'completed_with_errors', 'failed']);

export const useBulkJobPolling = ({ jobId, enabled, intervalMs = 2000, onTerminalStatus }) => {
  const [jobStatus, setJobStatus] = useState(null);
  const [pollingError, setPollingError] = useState(null);
  const intervalRef = useRef(null);
  const terminalCallbackRef = useRef(onTerminalStatus);

  useEffect(() => {
    terminalCallbackRef.current = onTerminalStatus;
  }, [onTerminalStatus]);

  useEffect(() => {
    if (!enabled || !jobId) {
      setJobStatus(null);
      setPollingError(null);
      return undefined;
    }

    let cancelled = false;

    const stop = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    const poll = async () => {
      try {
        const nextStatus = await bulkImportApi.getJobStatus(jobId);
        if (cancelled) return;

        setJobStatus(nextStatus);
        setPollingError(null);

        if (TERMINAL_STATUSES.has(nextStatus.status)) {
          stop();
          terminalCallbackRef.current?.(nextStatus);
        }
      } catch (error) {
        if (cancelled) return;
        setPollingError(error.message || 'Failed to refresh job status');
      }
    };

    poll();
    intervalRef.current = setInterval(poll, intervalMs);

    return () => {
      cancelled = true;
      stop();
    };
  }, [enabled, jobId, intervalMs]);

  return { jobStatus, pollingError };
};

export default useBulkJobPolling;
